<my-header></my-header>
<div class="my-account spc-type">
  <div class="title"></div>
</div>

<div class="spc-container">
  <div class="spc-main">
    <!-- </div>
      </div> -->
    <!-- Back Button (keeps File 2 visual; works with your goBack() handler) -->
    <div class="left-arrow top_71" (click)="goBack()">
      <img alt="home" class="home" src="./assets/images/arrow.svg" />
      <span class="back-text">Back</span>
    </div>

    <!-- Search + Filter (hidden when Asepha chat is shown) -->
    <div [ngClass]="{ 'spc-search': !showAsephaChat, 'hidden': showAsephaChat }">
      <div class="search-bar">
        <span class="material-symbols-outlined">search</span>
        <input type="text" class="spc-inputTxt" (input)="onSearch($event)" placeholder="Search" />
      </div>
      <div class="spc-filter" (click)="togglePopup()" #menuIcon>
        <span class="material-symbols-outlined">filter_list</span>
      </div>
    </div>

    <!-- Filter Dropdown -->
    <div id="popup-menu" class="filter-popup-menu filter-space-y-4" #popupMenu #breadcrumbs>
      <a *ngFor="let item of dateList" (click)="showSection(item.Id)">
        <span class="drp-items">{{ item.Name }}</span>
      </a>
    </div>

    <!-- Chat History (hidden when Asepha chat is shown) -->
    <div class="spc-history" [class.has-preview]="selectedImageUrl" *ngIf="!showAsephaChat">
      <app-spc-chat-history
        [filterPeriod]="selectedPeriod"
        [patientID]="patientID"
        [patientName]="patientName"
        [npi]="npi"
        [messages]="messages"
        [enterMessage]="enterMessage"
        [searchText]="searchText">
      </app-spc-chat-history>
    </div>

    <!-- Input & Actions (hidden when Asepha chat is shown) -->
    <div class="spc-input" *ngIf="!showAsephaChat">

      <!-- Left side: text + preview chip -->
      <div class="spc-enter">

        <!-- Small preview chip (from File 1) -->
 <div class="preview-wrapper" *ngIf="_picked.length > 0">
  <div class="preview-chip" *ngFor="let item of _picked; let i = index">
    <img [src]="item?.url" alt="preview" (click)="openImagePreview(item?.url)" />
    <span class="preview-chip__close" (click)="removeSelectedImage(i)">×</span>
  </div>
</div>


        <!-- Text input (keeps File 2 mobile-friendly attributes) -->
        <input
          type="text"
          id="enteredMessage"
          [(ngModel)]="enteredMessage"
          class="spc-inputTxt"
          [placeholder]="placeholderMessage"
          (keydown)="onEnter($event)"
          (focus)="onFocus()"
          [ngClass]="{ 'error-placeholder': isError }"
          [attr.autocorrect]="'on'"
          [attr.autocapitalize]="'sentences'"
          [attr.autocomplete]="'off'"
          [attr.enterkeyhint]="'send'"
          [attr.returnKeyType]="'done'"
          [attr.inputmode]="'text'"
        />

        <!-- Hidden inputs (from File 1) -->
        <input #cameraInput type="file" accept="image/*" hidden (change)="handleFileInput($event)" />
        <input #fileInput type="file" accept="image/*" hidden (change)="handleFileInput($event)" />
      </div>

      <!-- Right side: icons + send (from File 1) -->
      <div class="spc-actions">
        <button type="button" class="spc-action" (click)="fileInput.click()" aria-label="Attach file">
        <img src="./assets/images/attachment.svg" alt="Attach" class="attach-icon" />
        </button>

         <button type="button" class="spc-action" (click)="openCamera()" aria-label="Open camera">
          <img src="./assets/images/camera.svg" alt="Attach" class="attach-icon" />
         </button>

        <button type="button" class="send-button" (click)="sendMessage()" aria-label="Send">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 960 960" width="24px" fill="currentColor" class="send-icon">
            <path d="M120 800V560l320-80-320-80V160l760 320L120 800Z" />
          </svg>
        </button>
      </div>
  </div>
      <!-- Fullscreen image preview (from File 1) -->
      <div class="spc-lightbox" *ngIf="isImagePreviewOpen" (click)="closeImagePreview()">
        <div class="spc-lightbox__content" (click)="$event.stopPropagation()">
          <button class="spc-lightbox__close" type="button" aria-label="Close" (click)="closeImagePreview()">×</button>
          <img [src]="selectedImageUrl" alt="Full preview" class="spc-lightbox__image" />
        </div>
      </div>

      <!-- Camera Popup (from File 1) -->
      <div class="camera-modal" *ngIf="isCameraOpen" (click)="closeCamera()">
        <div class="camera-modal__content" (click)="$event.stopPropagation()">
          <button class="camera-modal__close" type="button" aria-label="Close" (click)="closeCamera()">×</button>

          <div class="camera-modal__title">Capture Image</div>

          <div class="camera-modal__video-wrap">
            <video #video autoplay playsinline></video>
            <div class="camera-modal__frame"></div>
          </div>

          <div class="camera-actions">
            <button class="btn btn-primary" type="button" (click)="capturePhoto()">Capture</button>
            <button class="btn btn-ghost" type="button" (click)="closeCamera()">Cancel</button>
          </div>
        </div>
      </div>
  

    <!-- Asepha Chat Iframe (shows only when toggled ON) -->
    <iframe
      *ngIf="showAsephaChat && asephaChatUrl"
      [src]="asephaChatUrl"
      class="asepha-iframe"
      frameborder="0"
      scrolling="no">
    </iframe>
<my-footer></my-footer>
